var _g, _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusIconSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 12,
    className: "outer",
    cy: 12,
    cx: 12,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 7,
    className: "spinner",
    cy: 12,
    cx: 12,
    strokeWidth: 6,
    stroke: "url('#gradient')"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4,
    className: "center",
    cy: 12,
    cx: 12,
    strokeWidth: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    gradientTransform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    className: "start"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    className: "stop"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIconSpinner);
export default __webpack_public_path__ + "static/media/status-icon-spinner.7cdd891f6ddd775f5b4f7737d8839d2b.svg";
export { ForwardRef as ReactComponent };